import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { Event } from '../../event.model';
import { AuthService } from 'src/app/auth/auth.service';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-event-details',
    templateUrl: './event-details.component.html',
    styleUrls: ['./event-details.component.scss'],
    standalone: false
})
export class EventDetailsComponent implements OnInit {
  event: Event;
  usedOnMobile: any;
  selected: any;

  constructor(public dialogRef: MatDialogRef<EventDetailsComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
              public authService: AuthService) {
                this.event = this.data.event;
                this.selected = this.data.selected;
                this.usedOnMobile = true;
              }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  usedOnMobileToggle(event: any) {
    this.usedOnMobile = event.source.checked;
    // used on mobile API
  }

}
